import { withNamespaces } from "react-i18next";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import GeoMap from "src/modules/3rd-party-management/components/geo-map";

const ProducerMapModal = ({ t, isOpen, toggle, producer }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                {t('Location')}: {`${producer?.name?.class} - ${t(producer?.name?.name)}`} ({t(producer?.originCountry?.name)})
            </ModalHeader>
            <ModalBody>
                {producer?.geolocationReference && (
                    <GeoMap
                        readOnly={true}
                        preDefinedGeo={producer?.geolocationReference}
                        multiDraw={true}
                    />
                )}
            </ModalBody>
        </Modal>
    );
};

export default withNamespaces()(
    ProducerMapModal
);
